import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map, of, switchMap } from 'rxjs';
import { AuthenticationService } from '../services/auth/auth_service';
import { CheckAccessDataService } from '../services/checkaccess.data.service/checkaccess.data.service';
import { CookieService } from '../services/cookies/cookie_service';

/**
 * Redirects to the login page if the user is not logged in.
 * @param route
 * @param state
 * @returns boolean
 */
export const OnboardingGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const checkAccessDataService = inject(CheckAccessDataService);
  const cookieService = inject(CookieService);
  const authService = inject(AuthenticationService);
  const tenants = authService.getAllTenants();

  return of(cookieService.getCookie('loggedIn')).pipe(
    switchMap((loggedIn) => {
      if (!loggedIn) {
        const url = tenants?.length > 1 ? '/tenants/login' : '/login';
        router.navigate([url], {
          queryParams: { redirectTo: `${state.url}` },
        });
        return of(false);
      }
      return from(checkAccessDataService.ensureRolesReady()).pipe(
        map(() => {
          if (!checkAccessDataService.hasRole('clinician')) {
            router.navigate(['/not-clinician'], {
              queryParams: { redirectTo: `${state.url}` },
              queryParamsHandling: 'merge',
            });
            return false;
          }
          return true;
        })
      );
    })
  );
};
